'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

require('flickity-imagesloaded');

var _flickity = require('flickity');

var _flickity2 = _interopRequireDefault(_flickity);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeroCarousel = function HeroCarousel(el) {
  (0, _classCallCheck3.default)(this, HeroCarousel);

  this.el = el;
  var initialIndex = (0, _functional.getElements)('.her-Hero_Item').findIndex(function (el) {
    return el.dataset.initialIndex === 'true';
  });
  var _HeroCarousel = new _flickity2.default((0, _functional.getElement)('[data-carousel="carousel"]', { context: this.el }), {
    wrapAround: true,
    pageDots: false,
    cellAlign: 'center',
    setGallerySize: true,
    adaptiveHeight: true,
    prevNextButtons: false,
    imagesLoaded: true,
    touchVerticalScroll: false,
    dragThreshold: 30,
    initialIndex: initialIndex
  });

  // Setup custom buttons for main carousel
  var previousButtonsMain = (0, _functional.getElements)('.her-Controls_Previous');

  previousButtonsMain.forEach(function (previousButton) {
    previousButton.addEventListener('click', function () {
      _HeroCarousel.previous();
    });
  });

  var nextButtonsMain = (0, _functional.getElements)('.her-Controls_Next');

  nextButtonsMain.forEach(function (nextButton) {
    nextButton.addEventListener('click', function () {
      _HeroCarousel.next();
    });
  });

  _HeroCarousel.on('dragStart.el', function (event, pointer) {
    document.ontouchmove = function (e) {
      e.preventDefault();
    };
  });

  _HeroCarousel.on('dragEnd.flickity', function (event, pointer) {
    document.ontouchmove = function (e) {
      return true;
    };
  });

  _HeroCarousel.on('change', function (index) {
    document.querySelector('.her-Controls').setAttribute('data-current-style', _HeroCarousel.selectedElement.classList.contains('her-Hero_Item-dark') ? 'dark' : 'light');
  });

  window.BAO = window.BAO || {};
  window.BAO.HeroCarousel = _HeroCarousel;
};

exports.default = HeroCarousel;